/*
 * Zentrale Feedback-Schnittstelle für betty.
 *
 * UI-Komponenten sollen keine eigenen mailto-Links erzeugen.
 * Feedback wird ausschließlich über diese Schnittstelle geöffnet.
 *
 * Dadurch kann der Transport später zentral von E-Mail auf ein
 * eigenes Feedback-Formular oder Backend umgestellt werden, ohne
 * sämtliche Aufrufer in der App ändern zu müssen.
 */

export const BETTY_FEEDBACK_EMAIL =
  "dirk.paulsen@betty.works";

const FEEDBACK_TYPES = {
  feedback: {
    de: "Feedback",
    en: "Feedback",
  },

  problem: {
    de: "Problem",
    en: "Problem",
  },

  idea: {
    de: "Feature-Idee",
    en: "Feature Idea",
  },

  question: {
    de: "Frage",
    en: "Question",
  },
};

function normalizeLanguage(language) {
  return language === "de" ? "de" : "en";
}

function getFeedbackType(type, language) {
  const normalizedLanguage =
    normalizeLanguage(language);

  return (
    FEEDBACK_TYPES[type]?.[normalizedLanguage] ||
    FEEDBACK_TYPES.feedback[normalizedLanguage]
  );
}

export function createFeedbackMailto({
  type = "feedback",
  context = "",
  language = "de",
  details = "",
} = {}) {
  const normalizedLanguage =
    normalizeLanguage(language);

  const typeLabel = getFeedbackType(
    type,
    normalizedLanguage
  );

  const subject = context
    ? `betty ${typeLabel} – ${context}`
    : `betty ${typeLabel}`;

  const body =
    normalizedLanguage === "de"
      ? [
          "Hallo,",
          "",
          context
            ? `mein Feedback bezieht sich auf: ${context}`
            : "ich möchte Feedback zu betty geben.",
          "",
          details || "",
          "",
          "Mein Feedback:",
          "",
          "",
        ].join("\n")
      : [
          "Hello,",
          "",
          context
            ? `My feedback relates to: ${context}`
            : "I would like to give feedback about betty.",
          "",
          details || "",
          "",
          "My feedback:",
          "",
          "",
        ].join("\n");

  return (
    `mailto:${BETTY_FEEDBACK_EMAIL}` +
    `?subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`
  );
}

export function openFeedback(options = {}) {
  const mailto = createFeedbackMailto(options);

  window.location.href = mailto;
}
